// This file is auto generated using CMS based event tracking.
// Do not modify this file manually!
import { BaseTrackingContext } from '@goeuro/app/client/tracking-provider/src/cms/lib/BaseTrackingContext';

/* Properties block */
export type PageTypeContextProperties = {
  page_type: string;
};

/* Context definition block */
const schema = 'iglu:com.goeuro/page_type_context/jsonschema/2-0-3';
export const pageTypeContextName = 'page_type_context';
export class PageTypeContext extends BaseTrackingContext<PageTypeContextProperties> {
  constructor(properties: PageTypeContextProperties) {
    super(pageTypeContextName, schema, properties);
  }
}
